import { render } from "./AdminKennisbank.vue?vue&type=template&id=08bfb294&scoped=true"
import script from "./AdminKennisbank.vue?vue&type=script&lang=js"
export * from "./AdminKennisbank.vue?vue&type=script&lang=js"

import "./AdminKennisbank.vue?vue&type=style&index=0&id=08bfb294&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08bfb294"]])

export default __exports__